<template>
    <div id="app">
        <Alert />
        <Navbar class="mv-main-nav" />
        <ChangelogModal v-if="changes" />
        <AdminMessage />
        <router-view />
    </div>
</template>

<script>
import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import CKEditor from "@ckeditor/ckeditor5-vue";
import Navbar from "./components/Navbar";
import Alert from "@/components/Alert/Alert";
import ChangelogModal from "@/components/Changelog/ChangelogModal";
import AdminMessage from "@/components/AdminMessage/AdminMessage";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import "./assets/scss/base.scss";

Vue.use(BootstrapVue);
Vue.use(CKEditor);

export default {
    name: "app",
    components: {
        Navbar,
        Alert,
        ChangelogModal,
        AdminMessage
    },
    computed: {
        auth() {
            return this.$store.getters.getAuth;
        },
        storedVersion() {
            const storedVersion = this.$store.getters.getVersion;
            return storedVersion;
        },
        changes() {
            const prevVersion = this.storedVersion;
            const currentVersion = process.env.VUE_APP_VERSION;
            if (currentVersion != prevVersion && this.auth.isAuthentificated) {
                return true;
            }
            return false;
        }
    }
};
</script>